(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92],{

/***/ 70372:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

var _typeof = __webpack_require__(67425);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = useForceUpdate;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(43681));

var React = _interopRequireWildcard(__webpack_require__(2784));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useForceUpdate() {
  var _React$useReducer = React.useReducer(function (x) {
    return x + 1;
  }, 0),
      _React$useReducer2 = (0, _slicedToArray2["default"])(_React$useReducer, 2),
      forceUpdate = _React$useReducer2[1];

  return forceUpdate;
}

/***/ }),

/***/ 22807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.responsiveMap = exports.responsiveArray = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(26290));

var _extends3 = _interopRequireDefault(__webpack_require__(77028));

var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
exports.responsiveArray = responsiveArray;
var responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};
exports.responsiveMap = responsiveMap;
var subscribers = new Map();
var subUid = -1;
var screens = {};
var responsiveObserve = {
  matchHandlers: {},
  dispatch: function dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach(function (func) {
      return func(screens);
    });
    return subscribers.size >= 1;
  },
  subscribe: function subscribe(func) {
    if (!subscribers.size) this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe: function unsubscribe(token) {
    subscribers["delete"](token);
    if (!subscribers.size) this.unregister();
  },
  unregister: function unregister() {
    var _this = this;

    Object.keys(responsiveMap).forEach(function (screen) {
      var matchMediaQuery = responsiveMap[screen];
      var handler = _this.matchHandlers[matchMediaQuery];
      handler === null || handler === void 0 ? void 0 : handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register: function register() {
    var _this2 = this;

    Object.keys(responsiveMap).forEach(function (screen) {
      var matchMediaQuery = responsiveMap[screen];

      var listener = function listener(_ref) {
        var matches = _ref.matches;

        _this2.dispatch((0, _extends3["default"])((0, _extends3["default"])({}, screens), (0, _defineProperty2["default"])({}, screen, matches)));
      };

      var mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      _this2.matchHandlers[matchMediaQuery] = {
        mql: mql,
        listener: listener
      };
      listener(mql);
    });
  }
};
var _default = responsiveObserve;
exports["default"] = _default;

/***/ }),

/***/ 18228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(71600);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _react = __webpack_require__(2784);

var _useForceUpdate = _interopRequireDefault(__webpack_require__(70372));

var _responsiveObserve = _interopRequireDefault(__webpack_require__(22807));

function useBreakpoint() {
  var refreshOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var screensRef = (0, _react.useRef)({});
  var forceUpdate = (0, _useForceUpdate["default"])();
  (0, _react.useEffect)(function () {
    var token = _responsiveObserve["default"].subscribe(function (supportScreens) {
      screensRef.current = supportScreens;

      if (refreshOnChange) {
        forceUpdate();
      }
    });

    return function () {
      return _responsiveObserve["default"].unsubscribe(token);
    };
  }, []);
  return screensRef.current;
}

var _default = useBreakpoint;
exports.Z = _default;

/***/ }),

/***/ 30092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ PhoneAuthenticationForm; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/antd/es/tabs/index.js + 49 modules
var tabs = __webpack_require__(79265);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/Tabs/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            padding: 21px 70px;\n            font-size: 24px;\n          "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            font-size: 15px;\n          "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  &.ant-tabs-top > .ant-tabs-nav::before {\n    border-bottom: none;\n  }\n\n  .ant-tabs-nav .ant-tabs-nav-operations {\n    display: none !important;\n  }\n\n  & > .ant-tabs-nav {\n    margin-bottom: 0;\n    width: 100%;\n  }\n  & .ant-tabs-tab {\n    flex: 1;\n    font-weight: 600;\n    justify-content: center;\n    border-bottom-color: transparent;\n    ",
        "\n\n    &.ant-tabs-tab-active .ant-tabs-tab-btn {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const Tabs = (0,styled_components_browser_esm/* default */.ZP)(tabs/* default */.Z)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey70;
}, (param)=>{
    let { $size  } = param;
    return $size === "large" ? (0,styled_components_browser_esm/* css */.iv)(_templateObject()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
}, (param)=>{
    let { theme  } = param;
    return theme.colors.green100;
});
const TabPane = (0,styled_components_browser_esm/* default */.ZP)(Tabs.TabPane)(_templateObject3());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/Tabs/index.tsx



const Tabs_Tabs = (param)=>{
    let { size ="normal" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
        $size: size,
        ...props
    });
};
Tabs_Tabs.TabPane = TabPane;

// EXTERNAL MODULE: ../../node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(94187);
// EXTERNAL MODULE: ../../libs/data-access/src/generated/index.tsx + 5 modules
var generated = __webpack_require__(20229);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/AuthForm/index.tsx + 9 modules
var AuthForm = __webpack_require__(72363);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/AppContext/index.tsx + 1 modules
var AppContext = __webpack_require__(49194);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/flows/Login.tsx








const Login = (param)=>{
    let { redirectPath  } = param;
    const router = (0,next_router.useRouter)();
    const [loginUser] = (0,generated/* useLoginUserMutation */.OQE)({
        errorPolicy: "ignore"
    });
    const onSuccess = async ()=>{
        await loginUser();
        router.replace(redirectPath);
    };
    const appContext = (0,AppContext/* useAppContext */.bp)();
    const appName = appContext.app;
    const { loginSubtitle , userNotFoundErrorMessage , userRole  } = (0,react.useMemo)(()=>{
        let loginSubtitle;
        let userNotFoundErrorMessage;
        let userRole;
        switch(appName){
            case "Admin":
                {
                    loginSubtitle = "Please log in to your account.";
                    userNotFoundErrorMessage = "We cannot find your account. Are you registered as admin?";
                    userRole = generated/* UserRoleEnum.ADMIN */.tGl.ADMIN;
                    break;
                }
            case "Client":
                {
                    loginSubtitle = "Please log in to your account.";
                    userNotFoundErrorMessage = "We cannot find your account. Are you registered as client / company interviewer?";
                    userRole = generated/* UserRoleEnum.CLIENT */.tGl.CLIENT;
                    break;
                }
            case "Vetter":
                {
                    loginSubtitle = "Please log in to your account and happy Vetting!";
                    userNotFoundErrorMessage = "We cannot find your account. Are you registered as external Vetter? If you are a new Vetter, please register.";
                    userRole = generated/* UserRoleEnum.VETTER */.tGl.VETTER;
                    break;
                }
            default:
                {
                    throw new Error("Unhandled case");
                }
        }
        return {
            loginSubtitle,
            userNotFoundErrorMessage,
            userRole
        };
    }, [
        appName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
        flow: "login",
        userRole: userRole,
        onSuccess: onSuccess,
        userNotFoundErrorMessage: userNotFoundErrorMessage,
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
            direction: "vertical",
            size: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                    level: 4,
                    children: "Welcome back!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                    $size: 15,
                    children: loginSubtitle
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../libs/common-utils/src/phone.ts
var phone = __webpack_require__(36284);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/context.tsx
var context = __webpack_require__(21728);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/message/index.ts
var message = __webpack_require__(7476);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/flows/SignUp.tsx










const SignUp = (param)=>{
    let { redirectPath  } = param;
    const router = (0,next_router.useRouter)();
    const { logout  } = context/* useFirebase */.f2();
    const [signupVetter] = (0,generated/* useSignupVetterMutation */.hmU)();
    const onSuccess = async (user, values)=>{
        var ref;
        const { data  } = await signupVetter({
            variables: {
                input: {
                    ...(0,lodash.pick)(values, [
                        "firstName",
                        "lastName"
                    ]),
                    firebaseUid: user.uid,
                    phone: phone/* normalize */.F(values.phone),
                    channel: values.otherChannel || values.channel
                }
            }
        });
        if (!data) {
            message/* message.error */.y.error("Something went wrong. Our team was notified and we're working on fixing the issue.");
            await logout();
            return;
        }
        if (((ref = data.signupVetter) === null || ref === void 0 ? void 0 : ref.__typename) === "ValidationError") {
            message/* message.error */.y.error(data.signupVetter.messages[0]);
            await logout();
            return;
        }
        router.replace(redirectPath);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
        flow: "signup",
        onSuccess: onSuccess,
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
            direction: "vertical",
            size: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                    level: 4,
                    children: "Become a professional interviewer!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                    $size: 15,
                    children: "Join our exclusive network of Vetters today and start earning from right where you are."
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/antd/es/avatar/index.js + 5 modules
var avatar = __webpack_require__(54371);
// EXTERNAL MODULE: ../../node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(18228);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/OrbitingBackground/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  100% { \n    transform:rotate(360deg); \n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 120vw;\n  height: 120vw;\n  position: fixed;\n  overflow: hidden;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: ",
        "px;\n      top: ",
        "px;\n    "
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 70px;\n  height: 70px;\n  ",
        "\n  border-radius: 100px;\n  background: #fff center center;\n  background-size: 85%;\n  box-shadow: inset 1px 1px 2px 0 rgba(0, 0, 0, 0.2);\n\n  margin-top: -35px;\n  margin-left: -35px;\n  & > .ant-avatar {\n    display: flex;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n\n  border: 1px solid #b38ef3;\n  border-radius: ",
        "px;\n  width: ",
        "px;\n  height: ",
        "px;\n\n  animation: ",
        " ",
        "",
        " linear infinite; linear infinite;\n  \n    & ",
        " {\n      animation: ",
        " ",
        "",
        " linear infinite;\n    }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}

const rotateAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(styles_templateObject());
const Wrap = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject1());
const Dot = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject3(), (param)=>{
    let { $initialAngle , $diameter  } = param;
    // Point on circle: 𝑥=𝑟sin𝜃 , 𝑦=𝑟cos𝜃.
    const r = $diameter / 2;
    const initialAngleRadians = $initialAngle * Math.PI / 180;
    const [x, y] = [
        Math.floor(r * Math.sin(initialAngleRadians) * 100) / 100,
        Math.floor(r * Math.cos(initialAngleRadians) * 100) / 100
    ];
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2(), r - x, r - y);
});
const DotOrbit = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), (param)=>{
    let { $diameter  } = param;
    return $diameter;
}, (param)=>{
    let { $diameter  } = param;
    return $diameter;
}, (param)=>{
    let { $diameter  } = param;
    return $diameter;
}, rotateAnimation, (param)=>{
    let { $duration  } = param;
    return $duration;
}, (param)=>{
    let { $direction  } = param;
    return $direction > 0 ? "" : " reverse";
}, Dot, rotateAnimation, (param)=>{
    let { $duration  } = param;
    return $duration;
}, (param)=>{
    let { $direction  } = param;
    return $direction > 0 ? " reverse" : "";
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/OrbitingBackground/index.tsx





const OrbitingBackground = (param)=>{
    let { children  } = param;
    const { xs  } = (0,useBreakpoint/* default */.Z)();
    return xs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DotOrbit, {
                        $diameter: 825,
                        $duration: "200s",
                        $direction: -1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                            $diameter: 825,
                            $initialAngle: 90,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                shape: "circle",
                                src: "/images/orbiting-background/gal_1_90.png"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DotOrbit, {
                        $diameter: 1008,
                        $duration: "240s",
                        $direction: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                $diameter: 1008,
                                $initialAngle: 315,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                    shape: "circle",
                                    src: "/images/orbiting-background/gal_2_315.png"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                $diameter: 1008,
                                $initialAngle: 225,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                    shape: "circle",
                                    src: "/images/orbiting-background/dude_2_225.png"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DotOrbit, {
                        $diameter: 1198,
                        $duration: "380s",
                        $direction: -1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                $diameter: 1198,
                                $initialAngle: 45,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                    shape: "circle",
                                    src: "/images/orbiting-background/dude_3_45.png"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                $diameter: 1198,
                                $initialAngle: 135,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                    shape: "circle",
                                    src: "/images/orbiting-background/dude_3_135.png"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                $diameter: 1198,
                                $initialAngle: 280,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                    shape: "circle",
                                    src: "/images/orbiting-background/gal_3_280.png"
                                })
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Card/index.tsx + 1 modules
var Card = __webpack_require__(28353);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/router/index.tsx + 1 modules
var src_router = __webpack_require__(41689);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Link/index.tsx




const Link = (param)=>{
    let { href , children , ...props } = param;
    const { getPath  } = (0,src_router/* useCustomRouter */.cD)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        ...props,
        href: getPath(href),
        children: children
    });
};

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/styles.ts

function PhoneAuthenticationForm_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: url('/images/boarding.svg') no-repeat center center fixed;\n  background-size: cover;\n  flex-direction: column;\n"
    ]);
    PhoneAuthenticationForm_styles_templateObject = function() {
        return data;
    };
    return data;
}
function PhoneAuthenticationForm_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 35px;\n"
    ]);
    PhoneAuthenticationForm_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function PhoneAuthenticationForm_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 81px;\n  height: 28px;\n  z-index: 2;\n  position: relative;\n\n  background: rgba(118, 62, 217, 0.4);\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    PhoneAuthenticationForm_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function PhoneAuthenticationForm_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 81px;\n  height: 28px;\n  z-index: 2;\n  position: relative;\n\n  display: none;\n\n  ",
        " {\n    align-self: center;\n    margin: auto;\n    margin-bottom: 40px;\n    display: block;\n  }\n"
    ]);
    PhoneAuthenticationForm_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  width: 541px;\n  min-height: fit-content;\n  padding-top: 32px;\n\n  ",
        " {\n    width: 100vw;\n    min-height: 100vh;\n    margin-top: 0;\n  }\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-tabs-nav-list {\n    width: fill-available;\n    justify-content: center;\n    margin: 0 0 40px 0;\n    overflow-x: hidden;\n  }\n  & .ant-tabs-tab {\n    display: flex;\n    flex: unset;\n    justify-content: center;\n    width: max-content;\n    padding: 10px 0px;\n    margin: 0px 20px;\n    ",
        " {\n      padding: 21px 0;\n    }\n  }\n  & .ant-tabs-nav-more {\n    display: none;\n  }\n  & .ant-tabs-tab-btn {\n    color: ",
        ";\n  }\n  & .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}




const BREAKPOINT = "@media(max-width: 576px)";
const Wrapper = styled_components_browser_esm/* default.div */.ZP.div(PhoneAuthenticationForm_styles_templateObject());
const styles_Link = (0,styled_components_browser_esm/* default */.ZP)(Link)(PhoneAuthenticationForm_styles_templateObject1());
const LogoDesktop = styled_components_browser_esm/* default.img */.ZP.img(PhoneAuthenticationForm_styles_templateObject2(), BREAKPOINT);
const LogoMobile = styled_components_browser_esm/* default.img */.ZP.img(PhoneAuthenticationForm_styles_templateObject3(), BREAKPOINT);
const styles_Card = (0,styled_components_browser_esm/* default */.ZP)(Card/* Card */.Z)(styles_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, BREAKPOINT);
const SpacedTabs = (0,styled_components_browser_esm/* default */.ZP)(Tabs_Tabs)(_templateObject5(), BREAKPOINT, (param)=>{
    let { theme  } = param;
    return theme.colors.grey70;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
});

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Space/styles.ts
var Space_styles = __webpack_require__(81983);
// EXTERNAL MODULE: ../../node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(48562);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/state.ts
var state = __webpack_require__(8261);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/initializeAuth.ts
var initializeAuth = __webpack_require__(90854);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/flows/AcceptInvitation.tsx







const AcceptInvitation = (param)=>{
    let { redirectPath  } = param;
    var ref;
    const { router  } = (0,src_router/* useCustomRouter */.cD)();
    const { user , logout , refetchToken  } = state/* useAuth */.a();
    const query = new URLSearchParams(window.location.search);
    const invitationKey = query.get("key");
    const safeLogout = (0,react.useCallback)(async ()=>{
        if (user) await logout();
    }, [
        user,
        logout
    ]);
    (0,react.useEffect)(()=>{
        if (!invitationKey) {
            message/* message.error */.y.error("Sorry, this invitation link is no longer valid");
            router.replace("/404");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { data , loading: clientUserInvitationLoading  } = (0,generated/* useClientByInvitationKeyQuery */.L_r)({
        variables: {
            invitationKey: invitationKey
        },
        skip: !invitationKey,
        onCompleted: (param)=>{
            let { clientByInvitationKey  } = param;
            if ((clientByInvitationKey === null || clientByInvitationKey === void 0 ? void 0 : clientByInvitationKey.__typename) === "NotFoundError") {
                message/* message.error */.y.error("Sorry, this invitation link is no longer valid");
                router.replace("/404");
            }
        }
    });
    const [acceptUserInvite] = (0,generated/* useAcceptUserInviteMutation */.amW)({
        onCompleted: (param)=>{
            let { acceptUserInvite  } = param;
            if ((acceptUserInvite === null || acceptUserInvite === void 0 ? void 0 : acceptUserInvite.__typename) === "User") {
                message/* message.success */.y.success("Invitation Accepted successfully");
            } else if ((acceptUserInvite === null || acceptUserInvite === void 0 ? void 0 : acceptUserInvite.__typename) === "ValidationError") {
                message/* message.error */.y.error(acceptUserInvite.messages[0] || acceptUserInvite.messages);
            } else if ((acceptUserInvite === null || acceptUserInvite === void 0 ? void 0 : acceptUserInvite.__typename) === "NotFoundError") {
                message/* message.error */.y.error(acceptUserInvite.message);
                router.replace("/404");
            }
        }
    });
    const onSuccess = async (user, values)=>{
        var ref;
        if (!invitationKey || !values.firstName || !values.lastName) {
            message/* message.error */.y.error("Some of required values are not provided.");
            return;
        }
        await acceptUserInvite({
            variables: {
                input: {
                    firebaseUid: user.uid,
                    invitationKey,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    phone: values.phone
                }
            }
        });
        await refetchToken();
        await ((ref = initializeAuth/* auth.currentUser */.I.currentUser) === null || ref === void 0 ? void 0 : ref.getIdTokenResult(true));
        window.location.href = redirectPath;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
        flow: "acceptInvitation",
        onSuccess: onSuccess,
        safeLogout: safeLogout,
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
            direction: "vertical",
            size: 4,
            $fullWidth: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Title */.Dx, {
                    $size: 36,
                    children: [
                        "Welcome",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "img",
                            "aria-label": "wave",
                            children: "\uD83D\uDC4B"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Text */.xv, {
                            $size: 15,
                            children: [
                                "You’ve been invited to join the",
                                " ",
                                clientUserInvitationLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                    active: true,
                                    block: false,
                                    size: "small"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        (data === null || data === void 0 ? void 0 : (ref = data.clientByInvitationKey) === null || ref === void 0 ? void 0 : ref.__typename) === "Client" ? data.clientByInvitationKey.companyName : "",
                                        " "
                                    ]
                                }),
                                "team, please complete your personal information below."
                            ]
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/index.tsx










const PhoneAuthenticationForm = (param)=>{
    let { routes ={
        login: "/login",
        signup: "/signup"
    } , defaultRedirectPath ="/dashboard" , currentTab  } = param;
    const router = (0,next_router.useRouter)();
    var ref;
    const redirectPath = (0,react.useMemo)(()=>{
        var ref1;
        return (ref = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.redirect) !== null && ref !== void 0 ? ref : defaultRedirectPath;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        defaultRedirectPath
    ]);
    (0,react.useEffect)(()=>{
        for (const route of Object.values(routes)){
            router.prefetch(route);
        }
    }, [
        router,
        routes
    ]);
    const handleTabClick = (0,react.useCallback)((key)=>{
        const route = routes[key];
        if (route) {
            router.replace(route);
        }
    }, [
        router,
        routes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrbitingBackground, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Link, {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoDesktop, {
                        src: "/fullLogo.svg"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Card, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Space_styles/* Space */.T, {
                        direction: "vertical",
                        size: 0,
                        $fullWidth: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoMobile, {
                                    src: "/logoPurple.svg"
                                })
                            }),
                            currentTab ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpacedTabs, {
                                size: "large",
                                defaultActiveKey: currentTab,
                                onTabClick: handleTabClick,
                                centered: true,
                                children: [
                                    !!routes["signup"] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs.TabPane, {
                                        tab: "Sign up",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUp, {
                                            redirectPath: defaultRedirectPath
                                        })
                                    }, "signup"),
                                    !!routes["login"] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs.TabPane, {
                                        tab: "Log in",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                                            redirectPath: redirectPath
                                        })
                                    }, "login")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AcceptInvitation, {
                                redirectPath: redirectPath
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 28353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/antd/es/card/index.js + 3 modules
var card = __webpack_require__(22419);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Card/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin: 0 !important;\n      "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding: 0 !important;\n      "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          height: fill-available;\n        "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 0;\n  min-height: max-content;\n  padding: 12px;\n  height: 100%;\n  & .ant-card-body {\n    height: 100%;\n  }\n  & .ant-card-head {\n    border-bottom: none;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: 576px) {\n    max-width: ",
        ";\n    padding: 50px 40px 40px 40px;\n    border-radius: 18px;\n    height: ",
        ";\n    width: ",
        ";\n    & .ant-card-body {\n      padding: 0;\n      ",
        ";\n    }\n    margin: 36px;\n  }\n\n  @media (max-height: 576px) and (orientation: landscape) {\n    border-radius: 0;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: block;\n          width: 100%;\n        "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: flex;\n        "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: 100%;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}


const Card = (0,styled_components_browser_esm/* default */.ZP)(card/* default */.Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.styles.gradient;
}, (param)=>{
    let { $disableMargins  } = param;
    return $disableMargins && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
}, (param)=>{
    let { $disablePaddings  } = param;
    return $disablePaddings && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
}, (param)=>{
    let { $noMaxWidth  } = param;
    return $noMaxWidth ? "unset" : "924px";
}, (param)=>{
    let { $height  } = param;
    return $height ? $height : "auto";
}, (param)=>{
    let { $width  } = param;
    return $width ? $width : "auto";
}, (param)=>// height:fill-available messes up the layout on Safari
{
    let { $disableFillAvailableHeight  } = param;
    return !$disableFillAvailableHeight && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});
const FullHeightRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject6(), (param)=>{
    let { $innerRowFullWidth  } = param;
    return $innerRowFullWidth ? (0,styled_components_browser_esm/* css */.iv)(_templateObject4()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Card/index.tsx



const Card_Card = (param)=>{
    let { width , height , noMaxWidth =false , innerRowFullWidth =false , disableMargins =false , disablePaddings =false , disableFillAvailableHeight =false , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
        ...props,
        $height: height,
        $width: width,
        $noMaxWidth: noMaxWidth,
        $disableMargins: disableMargins,
        $disablePaddings: disablePaddings,
        $disableFillAvailableHeight: disableFillAvailableHeight,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullHeightRow, {
            $innerRowFullWidth: innerRowFullWidth,
            children: children
        })
    });
};


/***/ }),

/***/ 85748:
/***/ (function(module) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 96314:
/***/ (function(module) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 26290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(47739);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 77028:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 66193:
/***/ (function(module) {

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 16147:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 43681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(96314);
var iterableToArrayLimit = __webpack_require__(66193);
var unsupportedIterableToArray = __webpack_require__(60121);
var nonIterableRest = __webpack_require__(16147);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 68064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(67425)["default"]);
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 47739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(67425)["default"]);
var toPrimitive = __webpack_require__(68064);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 60121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(85748);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

}]);